export type Falsy = false | 0 | -0 | 0n | '' | null | undefined | void;
